export default {
  computed: {
    cssProps() {
      return {
        '--primary-color': this.$vuetify.theme.themes.light.primary,
        '--primary-light-color': this.$vuetify.theme.themes.light['primary-light'],
        '--secondary-color': this.$vuetify.theme.themes.light.secondary,
        '--tertiary-light-color': this.$vuetify.theme.themes.light['tertiary-light'],
        '--default-color': this.$vuetify.theme.themes.light.default,
        '--default-1-color': this.$vuetify.theme.themes.light['default-1'],
        '--default-2-color': this.$vuetify.theme.themes.light['default-2'],
        '--default-dark-color': this.$vuetify.theme.themes.light['default-dark'],
        '--rouge-color': this.$vuetify.theme.themes.light.rouge,
        '--default-semilight-color': this.$vuetify.theme.themes.light['default-semilight'],
        '--default-light-color': this.$vuetify.theme.themes.light['default-light'],
        '--disabled-color': this.$vuetify.theme.themes.light.disabled,
        '--disabled-1-color': this.$vuetify.theme.themes.light['disabled-1'],
        '--disabled-light-color': this.$vuetify.theme.themes.light['disabled-light'],
        '--disabled-dark-color': this.$vuetify.theme.themes.light['disabled-dark'],
        '--border-light-color': this.$vuetify.theme.themes.light['border-light'],
        '--border-color': this.$vuetify.theme.themes.light.border,
        '--card-background-color': this.$vuetify.theme.themes.light['card-background'],
        '--golden-color': this.$vuetify.theme.themes.light.golden,
        '--crimson-color': this.$vuetify.theme.themes.light.crimson,
        '--french-blue-color': this.$vuetify.theme.themes.light['french-blue'],
        '--dark-slate-blue-color': this.$vuetify.theme.themes.light['dark-slate-blue'],
        '--warm-grey-color': this.$vuetify.theme.themes.light['warm-grey'],
        '--white-color': this.$vuetify.theme.white,
        '--pinkish-grey-color': this.$vuetify.theme.themes.light['pinkish-grey'],
        '--white-two-color': this.$vuetify.theme.themes.light['white-two'],
        '--light-pink': this.$vuetify.theme.themes.light['light-pink'],
        '--overlay-3-color': this.$vuetify.theme.themes.light['overlay-3'],
      };
    },
  },
};
